$(function() {
  const categoryLandingPageContainer = '.category-landing-container';
  function checkForCategoryLandingPage() {
    const isCategoryLandingPage = $(categoryLandingPageContainer);
    if (isCategoryLandingPage.length) {
      isCategoryLandingPage
        .parents('body')
        .addClass('category-landing-page__main');
    }
  }
  function positionHeader() {
    var headerHeight =
      $('.nav-marketing').outerHeight() + $('.nav-header').outerHeight();
    $('.home-container').css('margin-top', headerHeight);
  }
  function mobileAccessibility() {
    if (window.innerWidth <= 767) {
      $('.category-carousel__link')
        .find('div:not(.category-card-buttons)')
        .attr('aria-hidden', true);
      $('.category-carousel__link').each(function() {
        $(this)
          .find('.category-card-buttons button')
          .attr(
            'aria-label',
            $(this)
              .text()
              .trim()
          );
      });
    } else {
      $('.category-carousel__link')
        .find('div:not(.category-card-buttons)')
        .removeAttr('aria-hidden');

      $('.category-carousel__link')
        .find('.category-card-buttons button')
        .removeAttr('aria-label');
    }
  }
  positionHeader();
  checkForCategoryLandingPage();
  mobileAccessibility();
  $(window).on('resize', mobileAccessibility);
  $(window).on('resize', positionHeader);
  function signUpForAnAccount() {
    $('.header-signin')[0].click();
  }
  $(
    '.home-container .home-signUp-content-button-sign,.need-more-help-create-account'
  ).on('click', signUpForAnAccount);
});
